<ng-container *ngIf="!input.isList">
    <div class="input-container">
        <label [for]="input.id" *ngIf="input.label">
            {{ input.label }}
            <span class="mandatory" *ngIf="input.required">*</span>
        </label>
        <ng-container [ngSwitch]="input.type">
            <input *ngSwitchCase="parameterType.string" class="form-input" [id]="input.id" [formControl]="control" type="text" [ngClass]="{ error: hasErrors() }" [style]="input.label !== 'P_CLIENTE' ? input.style : 'width: 95%'" />
            <input *ngSwitchCase="parameterType.number" class="form-input" placeholder="Escribe solo números" [id]="input.id" [formControl]="control" type="text" [allowNegativeNumbers]="true" mask="separator.5" thousandSeparator="" [ngClass]="{ error: hasErrors() }" [style]="input.style" />
            <div *ngSwitchCase="parameterType.boolean" class="check-container" [style]="input.style">
                <input [id]="input.id" class="form-check-input mt-0" [ngClass]="{ error: hasErrors() }" [formControl]="control" type="checkbox" />
            </div>
            <input *ngSwitchCase="parameterType.date" class="form-input" [id]="input.id" [formControl]="control" placeholder="yyyy-mm-dd" ngbDatepicker #date="ngbDatepicker" (click)="date.toggle()" [ngClass]="{ error: hasErrors() }" [style]="input.style" />
        </ng-container>
        <button *ngIf="input.label === 'P_CLIENTE'" (click)="fileIdInput.click()" style="margin-left: 0.3rem; border: none">
            <fa-icon [icon]="faUpload" class="filter-icon"></fa-icon>
            <input hidden #fileIdInput type="file" (change)="loadClientData($event)" />
        </button>
    </div>
</ng-container>
<ng-container *ngIf="input.isList">
    <div class="input-container">
        <label [for]="input.id" *ngIf="input.label">
            {{ input.label }}
            <span class="mandatory" *ngIf="input.required">*</span>
        </label>
        <select class="form-input" [id]="input.id" [formControl]="control" [ngClass]="{ error: hasErrors() }" [style]="input.style">
            <option [ngValue]="null" selected disabled hidden>Seleccione</option>
            <option *ngFor="let option of input.options" [value]="option">
                <ng-container [ngTemplateOutlet]="input.type === parameterType.date ? dateValue : defaultValue" [ngTemplateOutletContext]="{ value: option }"> </ng-container>
            </option>
        </select>
    </div>
</ng-container>

<ng-template #defaultValue let-value="value">
    {{ value }}
</ng-template>

<ng-template #dateValue let-value="value">
    {{ value | date : 'YYYY-MM-dd' }}
</ng-template>
